.http-message{background-color:#f9f9f9;border:1px solid #f1f1f1;padding:10px;border-radius:5px}
/*# sourceMappingURL=callback-history-table.component-DKGJGNVI.css.map */
